import { AppContextState } from './app.context';

type Message<T> = { type: 'SET'; key: string; value: T };

export function createCrossTabSync<T>(channelName: string) {
  const bc = new BroadcastChannel(channelName);

  return {
    post(msg: Message<T>) {
      bc.postMessage(msg);
    },
    onMessage(handler: (msg: Message<T>) => void) {
      const listener = (ev: MessageEvent<Message<T>>) => handler(ev.data);
      bc.addEventListener('message', listener);
      return () => bc.removeEventListener('message', listener);
    },
    close() {
      bc.close();
    },
  };
}

export const sync = createCrossTabSync<AppContextState>('app-context');
